import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
// import { baseUrl } from "./config/baseUrl";
// import axios from "axios";
// import { ToastMessgae } from "./Component/utils/toast";

export default function Protected({ Component }) {
  const navigate = useNavigate();
  const [next, setNext] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert to seconds

      if (decoded.exp < currentTime) {
        // Token expired
        localStorage.clear();
        navigate("/login");
        // ToastMessgae({ message: "Session expired. Please login again." });
      } else {
        // Token valid — optionally check with backend
        setNext(true);

        // If you want to double-check with backend uncomment this:
        /*
        const checkToken = async () => {
          try {
            const response = await axios.get(`${baseUrl}/module/admin/token-check`, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            if (response.data.code === 401) {
              localStorage.clear();
              navigate("/login");
              ToastMessgae({ message: "Please Login First" });
            } else {
              setNext(true);
            }
          } catch (error) {
            console.error("Token validation error:", error);
            navigate("/login");
            // ToastMessgae({ message: "An error occurred. Please try again." });
          }
        };
        checkToken();
        */
      }
    } catch (error) {
      console.error("Invalid token:", error);
      localStorage.clear();
      navigate("/login");
    }
  }, [navigate]);

  return <>{next ? <Component /> : null}</>;
}
